<ng-container *ngIf="control">
  <div
    class="form-field phone-form-field"
    [class.error]="control?.touched && control?.invalid && controlErrorKeys?.length && controlErrorKeys[0] !== 'validatePhoneNumber'"
  >
    <div class="country-tel-prefix-container">
      <ngx-material-intl-tel-input
        [preferredCountries]="preferredCountries"
        [enablePlaceholder]="true"
        [enableSearch]="true"
        [autoSelectedCountry]="'nl'"
        [autoIpLookup]="false"
        [outputNumberFormat]="outputNumberFormatE164"
        name="phone"
        [fieldControl]="control"
        (currentCountryCode)="onCountryChange($event)"
        #phoneInput
      ></ngx-material-intl-tel-input>
    </div>
    <mat-error *ngIf="control?.invalid && controlErrorKeys?.length">
<!--      <ng-container *ngIf="control.errors.required">-->
<!--        {{ 'form.error.required' | transloco }}-->
<!--      </ng-container>-->
      <ng-container *ngIf="control.errors.api_phone_validation_error">
        {{ 'form.error.invalid' | transloco }}
      </ng-container>
    </mat-error>
  </div>
</ng-container>
